import $ from "jquery";
import _ from "underscore";
import { CombinationRankingTableView } from "../view/combination_ranking_table_view";

class CombinationRankingTableController {
  private static readonly DEFAULT_ASPECT_ID = 0; // All
  private form: any;
  private statsType: string;
  private tableRootElement: JQuery<HTMLElement>;
  public view: any;
  private topPairingIds: any[];
  private itemLinkClickHandler?: (itemId: number, itemName: string) => void;

  constructor(
    form: any,
    statsType: string,
    tableRootElement: JQuery<HTMLElement>,
  ) {
    this.form = form;
    this.statsType = statsType;
    this.tableRootElement = tableRootElement;
    this.view = new CombinationRankingTableView(this.tableRootElement);
    this.topPairingIds = [];
  }

  initialize(): void {
    this.view.initialize();
  }

  render(
    aspectId: number = CombinationRankingTableController.DEFAULT_ASPECT_ID,
  ): JQuery.Promise<string> {
    const dfd = $.Deferred<string>();
    const query = new CombinationRankingTableQuery(
      this.form,
      this.statsType,
      aspectId,
    );

    query.execute().then(
      (table: any) => {
        this.view.renderCombinationRankingTable(table);
        this.view.updateCsvUrl(query.csvUrl());
        this.rebindItemLinkClick();
        dfd.resolve("resolved");
      },
      (_res: any) => {
        // error handling
        dfd.reject();
      },
    );

    return dfd.promise();
  }

  private itemLinksSelector(): string {
    return "a.keyword_link";
  }

  private itemLinks(): JQuery<HTMLElement> {
    return $(this.itemLinksSelector());
  }

  updateRankingTable(aspectId: number): void {
    this.view.clearTable();
    this.view.showIndicator();
    this.render(aspectId);
    this.rebindItemLinkClick();
  }

  onItemLinkClick(handler: (itemId: number, itemName: string) => void): void {
    this.itemLinkClickHandler = handler;
    this.itemLinks().click((e) => {
      const itemId = $(e.currentTarget).data("itemId");
      const itemName = $(e.currentTarget).text();
      return handler(itemId, itemName);
    });
  }

  private rebindItemLinkClick(): void {
    const handler = this.itemLinkClickHandler;
    if (!handler) return;

    $(document).off("click", this.itemLinksSelector());
    $(document).on("click", this.itemLinksSelector(), (e) => {
      const itemId = $(e.currentTarget).data("itemId");
      const itemName = $(e.currentTarget).text();
      return handler(itemId, itemName);
    });
  }

  highlightSelection(): void {
    _(this.form.selection.items()).each(
      (pairingItemId: number, seq: number) => {
        this.highlight(pairingItemId, seq + 1);
      },
    );
  }

  private highlight(itemId: number, seq: number): void {
    $(`.ranking_cell_${itemId}`).addClass(`selected_cell_${seq}`);
  }
}

class CombinationRankingTableQuery {
  private form: any;
  private statsType: string;
  private aspectId: number;

  constructor(form: any, statsType: string, aspectId: number) {
    this.form = form;
    this.statsType = statsType;
    this.aspectId = aspectId;
  }

  execute(): JQuery.jqXHR {
    return $.ajax({
      url: this.form.combinationRankingTableUrl(),
      dataType: "json",
      data: this.makeParams(),
    });
  }

  private makeParams(): any {
    return {
      item_id: this.form.itemId(),
      start: this.form.startDate(),
      end: this.form.endDate(),
      type: this.statsType, // always use same stats type (ksi or kci) for ranking table
      partition: this.form.partition(),
      dimension: this.form.dimension(),
      aspect: this.aspectId,
      area: this.form.area(),
      category: this.form.category(),
      max_rank: this.form.maxRank(),
      "selection[]": this.form.selection.items(),
    };
  }

  csvUrl(): string {
    return `/combinations/${this.form.itemId()}/ranking.csv?${$.param(this.makeParams())}`;
  }
}

export { CombinationRankingTableController };
